import { Component, AfterViewInit } from '@angular/core';
import { MessageclientService } from '../../../../service/messageclient.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Platform } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { WebParameterContext } from '../../../../model/common';
import { HandleWebParameterContextBeforeDBRequest,HandleServerContextAfterDBRequest } from "../../../../bizlogic/servicesbll";
import { GridBaseCase } from '../../grid/grid.base.case';
import { CommonService } from 'src/service/common.service';
declare var app;

@Component({
  selector: 'app-mz-calendar',
  templateUrl: './mz-calendar.component.html',
  styleUrls: ['./mz-calendar.component.scss']
})
export class MzCalendarComponent extends GridBaseCase implements AfterViewInit{
  ch: any;//日历汉化配置
  data:Date;
  checkDate: any = new Date();//选中的日期
  /**
   * 所有日程
   */
  scheduleDate = [];

  /** 
   * 当前选中日程
  */
  currentSchedule = [];

  constructor(
    private msg: MessageclientService,
    private activaRouter: ActivatedRoute,
    private platform: Platform,
    private http: HttpCustomerService,
    private router: Router,
     private com: CommonService,
  ) {
    super();
    this.ch = {
      /** 每周第一天，0代表周日 */
      firstDayOfWeek: 0,
      /** 每周天数正常样式 */
      dayNames: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
      /** 每周天数短样式（位置较小时显示） */
      dayNamesShort: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      /** 每周天数最小样式 */
      dayNamesMin: ["日", "一", "二", "三", "四", "五", "六"],
      /** 每月月份正常样式 */
      monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
      /**每月月份短样式 */
      monthNamesShort: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      today: '今天',
      clear: '清除'
    };
  }
  segment = [
    { name: '月', value: '0' },
    { name: '周', value: '1' },
    { name: '日', value: '2' },
    { name: '日程', value: '3' }
  ];
  segmentVal: any = 0;
  segmentChanged($event) {
   
    this.segmentVal = $event.detail.value;
  }

  ngAfterViewInit() {
    const that = this;
    // that.getScheduleList();
  }


  /**
   * 获取日程列表
   */
  getScheduleList() {
    //.log(this.template);
    const that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();

    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else if (that.template.content.configName) {
      body.ConfigName = that.template.content.configName;
    }

    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = PageName;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body = HandleWebParameterContextBeforeDBRequest(body);
    if(!body.ResponseMessage.Success){
      that.msg.Alert(body.ResponseMessage.ErrorMessage);
      return;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      data = HandleServerContextAfterDBRequest(body,data);
      that.scheduleDate = [];
      if (data.ResponseMessage.Success) {

        // that.scheduleDate = data.Status.Datas;
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          if(that.template.content){
            that.template.content.element[0].selectItemList.selectItem.forEach((element, index) => {
              if(element.bindingField){
                objfield[element.bindingField] = item[element.field];
              }
            });
            that.scheduleDate.push(objfield);
          }
        });

        that.getCurrentSchedule(that.checkDate);
      }
    }).catch(error => {
      //.log(error);
      // that.msg.Alert(error.error.ResponseMessage.ErrorMessage).then(data => {
      //   //that.router.navigate(["/login"]);
      // })
    })
  }

    /**
  * 下拉刷新数据
  * @param event
  */
//  doRefresh(event) {
//   this.getScheduleList();
//   event.target.complete();
// }



  /**
   * 获取当天日程
   */
  getCurrentSchedule(day) {
    //.log("1001011");
    let that = this;
    that.currentSchedule = [];
    let d = this.DateFormat(day);
    this.scheduleDate.forEach(function (item, i) {
      if (item.date && item.date.indexOf(d) > -1) {
        that.currentSchedule.push(item);
      }
    })
  }


  /**
   * 选中日期
   * @param ev 
   * @param d 
   */
  DateSelect(ev, d) {
    //.log("1001011");
    this.checkDate = d;
    this.getCurrentSchedule(this.checkDate);
    // this.msg.Show(ev.getDate());
  }

  /**
   * 创建日程
   */
  creatSchedule() {
    localStorage.setItem('a_RiQi',this.DateFormat(this.checkDate));
    // this.router.navigate(
    //   ['/tabs/contact/CalendarForm/add']);
      this.com.Go('/tabs/contact/CalendarForm/add');
  }


  /**
   * 判断日期是否存在日程
   * @param day 
   */
  getSchedule(date) {
    //.log("1001011");
    let date1 = '';
    if (!date) { return false; } else {
      date1 = date.year + '-' + (date.month + 1) + '-' + date.day;
    }
    let d = this.DateFormat(date1);
    let isSchedule = false;
    this.scheduleDate.forEach(function (item, i) {
      if (item.date && item.date.indexOf(d) > -1) {
        isSchedule = true;
      }
    })
    return isSchedule;
  }

  /**
   * 查看日程详情
   * @param item 选中的日程
   */
  scheduleDetail(item) {
    //.log("1001011");
    // this.router.navigateByUrl("/tabs/contact/CalendarForm/view/" + item['id']);
    this.com.Go("/tabs/contact/CalendarForm/view/" + item['id']);
  }

  /**
   * 格式化日期
   * @param date 日期
   */
  DateFormat(dateFormat) {
    let date = dateFormat;
    if (date) {
      date = new Date(date.toString().replace(/-/g,"/"));
    } else {
      return;
    }
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    if (m < 10) {
      m = '0' + m;
    }
    let d = date.getDate();
    if (d < 10) {
      d = '0' + d;
    }
    return y + '-' + m + '-' + d;
  }

}



